"use strict";
/**
 * @description 样式配置
 * @author wangfupeng
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    zIndex: 10000,
};
